/*
 * Public API Surface of ngx-cookie-service
 */

export * from './lib/cookie.service';
